// FIXME objectmodel conflict with babel, so fallback to require
const objectmodel = require('objectmodel');

const ObjectModel = objectmodel.ObjectModel;
// const ArrayModel = objectmodel.ArrayModel;

export default new ObjectModel({
  threadname: String,
  username: String,
  userpage: String,
  userJoinDate: String,
  userNumOfPosts: String,
  postTimestamp: String,
  postContent: String,
});
